export const iconFontAwesomeFoodBeveragePepperHot = (
	<i className="fa-solid fa-pepper-hot"></i>
);
